import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { Input } from '../../../common/Forms/Input/Input';

export default function CommercialForm({
  register,
  errors,
  editingSalesChannelId,
  onSubmit,
  closeForm,
}) {
  return (
    <form>
        <div className="parameters-page__create-panel">
        <h4 className="parameters-page__create-title">
            {editingSalesChannelId ? 'Editar' : 'Crear nuevo'} canal
        </h4>
        <div className="parameters-page__create-fields parameters-page__create-fields--city">
            <div
            className="row"
            style={{ width: '100%', alignItems: 'flex-start' }}
            >
            <Input
                bootstrap="col-12 col-md-4"
                label="Nombre del canal *"
                type="text"
                name="channel"
                register={register}
                placeholder="Coloque el nombre del canal de venta"
                errors={errors?.channel?.message}
            />
            <Input
                bootstrap="col-12 col-md-4"
                label="Abreviatura del canal *"
                type="text"
                name="shortName"
                register={register}
                placeholder="Coloque la abreviatura del canal de venta"
                errors={errors?.shortName?.message}
            />
            <div
                className="col-12 col-md-4 buttons-center-container"
                style={{ marginTop: '32px' }}
            >
                <ActionButton
                label={editingSalesChannelId ? 'Editar' : 'Guardar'}
                action={onSubmit}
                />
                <AltButton label="Cancelar" action={closeForm} />
            </div>
            </div>
        </div>
        </div>

    </form>
  );
}
